const productsOnPage = document.querySelector("#product-grid");
if (!productsOnPage) {
  console.error("Element with id #product-grid not found.");
}

let nextUrl = productsOnPage.dataset.nextUrl;

const loadMoreBtn = document.querySelector(".load-more_btn");
const loadMoreSpinner = document.querySelector(".load-more_spinner");

if (!loadMoreBtn || !loadMoreSpinner) {
  console.error(
    "Element with class .load-more_btn or .load-more_spinner not found."
  );
}

function loadMoreProducts() {
  if (!nextUrl) {
    console.error("No next URL to load more products.");
    return;
  }

  loadMoreBtn.style.display = "none";
  loadMoreSpinner.style.display = "block";

  fetch(nextUrl, {
    method: "GET",
    headers: {
      "Content-Type": "text/html",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.text();
    })
    .then((nextPage) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = nextPage;
      const newProducts = tempDiv.querySelectorAll("#product-grid li");

      if (!newProducts.length) {
        throw new Error("New products not found in the fetched page.");
      }

      // Collect existing product IDs
      const existingProductIds = new Set(
        [...productsOnPage.querySelectorAll("li")].map(product =>
          product.getAttribute("data-product-id")
        )
      );

      // Filter out duplicates based on product ID
      newProducts.forEach((product) => {
        const productId = product.getAttribute("data-product-id");
        if (!existingProductIds.has(productId)) {
          productsOnPage.appendChild(product);
        }
      });

      // Update the next URL for pagination
      const newNextUrl = tempDiv.querySelector("#product-grid").dataset.nextUrl;
      nextUrl = newNextUrl;

      if (nextUrl) {
        loadMoreBtn.style.display = "block";
      } else {
        loadMoreBtn.style.display = "none";
      }

      loadMoreSpinner.style.display = "none";
    })
    .catch((error) => {
      console.error("Error loading more products:", error.message);
      loadMoreSpinner.style.display = "none";
      loadMoreBtn.style.display = "block";
    });
}

loadMoreBtn.addEventListener("click", loadMoreProducts);
